import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export function CountPill({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        "cursor-default rounded-md bg-[var(--ui-badge-neutral-bg)] px-1.5 py-px text-[10px] leading-[15px] text-ui-text-muted tabular-nums",
        className,
      )}
    >
      {children}
    </span>
  )
}
